import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { withRouter } from 'react-router-dom';

import { Menu } from 'semantic-ui-react';

import '../css/TopNav.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import Auth from '../managers/AuthManager';

import { VIEW_SELECTION } from '../managers/NavigationManager';
import { TOP_NAV_NAME } from '../constants';

import GuidedTourService from '../services/GuidedTourService';
import InitService from '../services/InitService';
import ProfileMenuService from '../services/ProfileMenuService';
import TopNavService from '../services/TopNavService';
import UserService from '../services/UserService';

export default
@inject(
  'navigationManager',
  'topNavManager',
  'userManager')
@observer
class GenericTopNav extends Component {
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
    this.AriaSkipLink = SatCoreComponent('AriaSkipLink');
    this.LogoButtons = SatCoreComponent('LogoButtons');
    this.ProfileMenu = SatCoreComponent('ProfileMenu');
    this.menuBarRef = React.createRef();
  }

  componentDidMount() {
    const { topNavManager } = this.props;
    topNavManager.setActiveTopNavName(TOP_NAV_NAME.GenericTopNav);
    InitService.initActiveUserRoleAsHtmlBodyAttr();
  }

  componentWillUnmount() {
    InitService.removeHtmlBodyRoleAttr();
  }

  showProfile = () => {
    const { history } = this.props;
    history.push('/profile', { url: history.createHref(history.location) });
  };

  handleClickGuidedTour = () => {
    const { topNavManager } = this.props;
    topNavManager.setIsTopNavProfileMenuOpen(false);
    // Small delay to allow menu to fully close and clear active states before launching tour
    setTimeout(() => {
      GuidedTourService.launchGuidedTour();
    }, 300);
  };

  handleClickRoleSwitcher = () => {
    const { history } = this.props;
    GuidedTourService.removeGuidedTourLauncherIfApplicable();
    UserService.showRoleSwitcher(history);
  };

  handleLogout = async () => {
    const { history, navigationManager, t, topNavManager } = this.props;

    const strOfItemsToPreserve = '';

    const isRoleSwitcherView = navigationManager.viewSelection === VIEW_SELECTION.ROLE_SWITCHER;

    const externalLogoutUrl = !isRoleSwitcherView ? t('externalLogoutUrl') : t('externalLogoutUrlRoleSwitcher');

    InitService.doLogoutCleanUp(strOfItemsToPreserve, { externalLogoutUrl });

    if (!externalLogoutUrl || !topNavManager.allowLoginRedirectUrl) {
      navigationManager.setView(VIEW_SELECTION.LOGIN);
      history.replace('/signin');
    }
  }

  renderProfileMenu = () => {
    const { ProfileMenu, props: { profileMenu, t, userManager } } = this;
    const {
      profile: allowShowProfile = true,
      items: profileMenuOptionsFromMainViewOverride,
      logout: allowShowLogout = true
    } = profileMenu || {};

    const { allowSwitchRole } = userManager;
    const hasMultipleRoles = UserService.getAvailableRoleCount() > 1;

    const {
      PROFILE_MENU,
      profileMenuOrderArray
    } = ProfileMenuService.getProfileMenuInfo() || {};

    let options = [];

    const allMenuOptions = profileMenuOrderArray?.map?.((menuItemId) => {
      const menuItemObj = PROFILE_MENU[menuItemId];

      if (!menuItemObj) {
        return null;
      }

      const { _id, className, functionKey, menuTranslationKey } = menuItemObj;

      switch (_id) {
        case PROFILE_MENU.profile?._id:
          if (!UserService.hasActivePermissionId()) {
            return null;
          }
          if (!allowShowProfile) {
            return null;
          }
          break;
        case PROFILE_MENU.guidedTour?._id:
          if (!GuidedTourService.shouldAllowGuidedTourLauncher()) {
            return null;
          }
          break;
        case PROFILE_MENU.switchRole?._id:
          if (!UserService.hasActivePermissionId()) {
            return null;
          }
          if (!allowSwitchRole || !hasMultipleRoles) {
            return null;
          }
          break;
        case PROFILE_MENU.logout?._id:
          if (!allowShowLogout) {
            return null;
          }
          break;
        default:
          break;
      }

      return {
        _id,
        className,
        onClick: (event, _data) => {
          if (functionKey && this[functionKey]) {
            return this[functionKey]();
          }
        },
        text: t(menuTranslationKey)
      };
    }).filter((menuItem) => !!menuItem) || [];

    // If custom items exist, move logout to the end. Otherwise, keep original order.
    if (Array.isArray(profileMenuOptionsFromMainViewOverride) && profileMenuOptionsFromMainViewOverride.length > 0) {
      const profileMenuOptionsWithoutLogout = allMenuOptions.filter((item) => item._id !== 'logout');
      const logoutOption = allMenuOptions.find((item) => item._id === 'logout');

      options = [
        ...profileMenuOptionsWithoutLogout,
        ...profileMenuOptionsFromMainViewOverride,
        ...(logoutOption ? [logoutOption] : [])
      ];
    } else {
      options = allMenuOptions;
    }

    // TODO remove - hardcoded implementation fallback
    // let options = [allowShowLogout && { onClick: this.handleLogout, text: t('logout') }];
    // if (UserService.hasActivePermissionId()) {
    //   options = [
    //     allowShowProfile && {
    //       className: 'profile',
    //       onClick: this.showProfile,
    //       text: t('profile')
    //     },
    //     allowSwitchRole && hasMultipleRoles && {
    //       className: 'switchRole',
    //       onClick: () => UserService.showRoleSwitcher(history),
    //       text: t('switchRole')
    //     },
    //     ...(profileMenuOptionsFromMainViewOverride || []),
    //     allowShowLogout && { onClick: this.handleLogout, text: t('logout') }
    //   ];
    // }

    return (
      <ProfileMenu
        {...profileMenu}
        options={options} />
    );
  }

  render() {
    const { additionalClassName = '', history, location, t } = this.props;
    const { AriaSkipLink, LogoButtons } = this;

    let topNavClassName = 'topNav';
    topNavClassName += additionalClassName ? ` ${additionalClassName}` : '';

    return (
      <>
        <Menu
          as={(props) => <header id='top-nav-bar' role='tablist' {...props} ref={this.menuBarRef} />}
          className={topNavClassName}
          fixed='top'
          inverted
          onKeyDown={(e) => TopNavService.topNavHandleKeyDown(e, this.menuBarRef)}>
          <LogoButtons history={history} location={location} logoImg={Auth.logoStudent} navButton />
          <AriaSkipLink mainContentId='main-content' />
          <Menu.Menu
            aria-label={t('navigationPanel')}
            as={(props) => <nav {...props} />}
            position='right'
            role='navigation'>
            {this.renderProfileMenu()}
          </Menu.Menu>
        </Menu>
      </>
    );
  }
}

SatCoreRegister('GenericTopNav', withRouter(GenericTopNav));
